<template>
	<input v-model="value" @input="onInput($event)" autocomplete="off"/>
</template>
<script>
export default {
	// {{{ props
	props: {
		value: {
			type: String,
			default: ''
		}
	},
	// }}}
	// {{{ methods
	methods: {
		// {{{ onInput
		onInput (e) {
			this.$emit('input', e.target.value)
		}
		// }}}
	}
	// }}}
}
</script>



// WEBPACK FOOTER //
// CZQInput.vue?0ef8f582